/**
 * AutoDownloader Utility: Automatically converts generated reports into Word (.docx)
 * and triggers immediate browser download to the user's Downloads folder.
 */
export async function autoDownloadReport(
  reportText: string,
  agentName: string = 'ШІ-Аналітичний Звіт',
  agentId: string = 'report'
): Promise<void> {
  if (!reportText || typeof reportText !== 'string' || reportText.trim().length === 0) {
    return;
  }

  // Do not auto-download error messages
  if (reportText.startsWith('⚠️ ПОМИЛКА') || reportText.startsWith('⚠️ ERROR')) {
    return;
  }

  const cleanName = (agentName || agentId)
    .replace(/[^a-zA-Z0-9а-яА-ЯіІїЇєЄ_]/g, '_')
    .replace(/_+/g, '_')
    .slice(0, 45);

  const dateStr = new Date().toISOString().slice(0, 10);
  const fileNameDocx = `Звіт_${cleanName}_${dateStr}.docx`;

  try {
    const res = await fetch('/api/convert-md-to-docx', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        markdownText: reportText,
        title: agentName,
        author: 'Deep Research Hub'
      })
    });

    if (res.ok) {
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileNameDocx;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      console.log(`[AutoDownload] Report successfully saved to Downloads: ${fileNameDocx}`);
      return;
    }
  } catch (err) {
    console.error('[AutoDownload] DOCX conversion failed, falling back to TXT/MD:', err);
  }

  // Fallback text/markdown download if docx conversion endpoint fails
  try {
    const blob = new Blob([reportText], { type: 'text/markdown;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Звіт_${cleanName}_${dateStr}.md`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    console.log(`[AutoDownload] Fallback report saved: Звіт_${cleanName}_${dateStr}.md`);
  } catch (err) {
    console.error('[AutoDownload] Fallback download failed:', err);
  }
}
